import React from 'react';


export const Accordions = [
    {
    question: " What does Webuildd do ?",
    answer: " We are a fully integrated firm of architects, structural engineers, contractors, builders, interior designers, and consultants who develop Commercial, Residential & Industrial properties across all asset classes.",
    },
    {
    question: " Do you outsource your construction work or you have in-house ?",
    answer: " No. We don't outsource. We have our in-house team comprised of Designers, Architects, Structural Engineers, Engineers, Site Supervisors, and Quality Controllers, and everyone else to make your visions come alive.",
    },
    {
    question: " Why should anybody choose Webuildd ?",
    answer: " We are a third-generation family-owned construction business in Bengaluru, your one-stop shop for all building solutions. It is our mission to make the construction process an experience our customers enjoy. So, let's get started.",
    },
    {
    question: "  Do you sign a Contract with all info on Raw material, Design specs ?",
    answer: " Yes. We sign and give a bond paper, which shows all comprehensive details on Raw materials, Timelines & Payment schedules.",
    },
    {
    question: "  Do you take care of Government Approvals ?",
    answer: " Yes, we provide complete turnkey solutions, which includes Plan approval as well.",
    },
    {
    question: " How do you monitor quality ?",
    answer: " We assign a site engineer to your site, who monitors that RM & design is done, as per the working drawings & RM, as specified by Structural Engineer.",
    },
    {
    question: " How do you guarantee hassle-free work ?",
    answer: " The work is hassle-free because, we maintain transparency at every level, starting from the procuring of material/s, payments to execution. Also, the same is updated to the client/s regularly. Our entire team ensures that the quality is not compromised, at any point in your customer experience.",
    },
    {
    question: " How do you commit to the on-time completion of a project ?",
    answer: " We believe in the on-time completion of projects, so our team will remove obstacles, neutralize issues, and deliver on time. With our decades of experience in this industry, our processes are robust and perform flawlessly.",
    },
    {
    question: " How comfortable is your payment process ?",
    answer: " We take payments in stages, as indicated in the timelines committed to our customers. We have 15-22 payment cycles depending on the number of floors of construction. 30% of payment cycles will be in the range of 8% to 10%, while the remaining cycles in the range of; 2% to 6%. Payment cycles are explicitly mentioned, at the time of agreement.",
    },
    {
    question: " How do we start ?",
    answer: " First step would be to meet and understand the requirement and budget. Second, as per requirement, we will suggest design options till we get the final go-ahead from the client. Finally, the materials are decided and then the execution begins.",
    },
    {
    question: "  Who will select materials and how will it get delivered at site ?",
    answer: " The structure materials we use are from brands and will be used once approved by clients. All the finish materials will be finalized in presence of the client. Once finalized, delivery of the materials will be sourced accordingly.",
    },
    {
    question: "  What are the criteria for selecting a labour team ?",
    answer: " The selection of labourers involves a process. Our experts make sure that only well-skilled labourers are recruited.",
    },
    {
    question: "  Who do we contact during work ?",
    answer: " Civil Engineer will be the SPOC & you will have access to project coordinators at all stages.",
    },
    {
    question: " How many times the client has to visit ?",
    answer: " The client must visit for design finalization & approvals, agreement sign off & selection of Tiles, Granite * Bathroom Fittings, etc.",
    },
    {
    question: "  How does the customer receive updates on the status of the site ?",
    answer: " Our Site Engineer/Project Coordinator/ Civil Engineer will be updating the Client every week, as well as on-demand.",
    },
    {
    question: "  What is the excavation depth for the foundation ?",
    answer: " Usually, the fixed depth is 5 feet. However, the same is decided only after a thorough soil test.",
    },
    {
    question: " What is height from from road to Parking ?",
    answer: <> 1'6"</>,
    },
    {
    question: " Do you take care of Soil testing ?",
    answer: " Yes, we have experts taking care of soil testing. This service has a separate fee.",
    },
    {
    question: "Are you okay, if we have a Architect already with us, Can you only take of Construction & Interiors ?",
    answer: " Yes, we okay with that.",
    },
    {
    question: " What is the diameter of steel used for construction ?",
    answer: <> Usually, we use 8/10/12/16/20", but the same is decided based on the number of floors and the type of construction.</>,
    },
    {
    question: " What are the column sizes ?",
    answer: <> 8"x18" will be minimum column sizes.</>,
    },
    {
    question: " Do you share the blueprint with the client ?",
    answer: <> Yes, we will share the floor plans, structural design, foundation details, footing details & steel drawings with the customer, provided you work with design & build basis only.
    Industrial properties across all asset classes.
   </>,
    },
];